import React, { useState } from "react";
import { api } from "../lib/api";
import { Download } from "lucide-react";

const PERIODS = [
  { value: "month", label: "Aktueller Monat" },
  { value: "quarter", label: "Quartal" },
  { value: "year", label: "Jahr" },
  { value: "all", label: "Gesamt" },
];

export default function ExportButton({ endpoint, defaultFilename, withPeriod = true, label = "CSV-Export", testId = "csv-export" }) {
  const [open, setOpen] = useState(false);
  const [period, setPeriod] = useState("month");
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const params = withPeriod ? { period } : {};
      const resp = await api.get(endpoint, { params, responseType: "blob" });
      const blob = new Blob([resp.data], { type: "text/csv;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      // Filename aus Content-Disposition extrahieren, sonst default
      const cd = resp.headers["content-disposition"] || "";
      const m = /filename="([^"]+)"/.exec(cd);
      a.download = m ? m[1] : defaultFilename;
      a.click();
      URL.revokeObjectURL(url);
      setOpen(false);
    } catch (e) {
      alert("Export fehlgeschlagen");
    } finally {
      setBusy(false);
    }
  };

  if (!withPeriod) {
    return (
      <button onClick={download} disabled={busy} className="btn-outline inline-flex items-center gap-2 text-sm" data-testid={testId}>
        <Download size={16} /> {busy ? "Lade…" : label}
      </button>
    );
  }

  return (
    <div className="relative inline-block">
      <button onClick={() => setOpen(!open)} className="btn-outline inline-flex items-center gap-2 text-sm" data-testid={testId}>
        <Download size={16} /> {label}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 bg-white border border-falke-blue/10 rounded-xl shadow-lg p-3 z-30 w-56" data-testid={`${testId}-menu`}>
          <div className="text-xs uppercase tracking-wider text-falke-blue/60 mb-2">Zeitraum</div>
          <div className="space-y-1 mb-3">
            {PERIODS.map((p) => (
              <label key={p.value} className="flex items-center gap-2 text-sm cursor-pointer">
                <input type="radio" name="period" value={p.value} checked={period === p.value} onChange={() => setPeriod(p.value)} className="accent-falke-orange" />
                {p.label}
              </label>
            ))}
          </div>
          <button onClick={download} disabled={busy} className="btn-primary w-full !py-2 text-sm" data-testid={`${testId}-download`}>{busy ? "Lade…" : "Download"}</button>
        </div>
      )}
    </div>
  );
}
